import {httpClient} from '@/services/axios';
import {defaultResponse} from "@/helpers/functionsHelpers";

const END_POINT = '/api/';

class HealthyService {
  getVersion() {
    return httpClient.get(END_POINT).then((dataResponse) => {
      return defaultResponse(dataResponse);
    });
  }
}

export default new HealthyService();
